export const getSalesAreasState = (state) => state.salesAreas;

export const getSalesAreaState = (state) => state.salesArea;
